<template>
  <div class="loader flex-center h-7">
    <span v-for="i in 10" :key="i"></span>
  </div>
</template>
<style scoped>
.loader {
}

.loader span {
  width: 3px;
  height: 28px;
  margin: 0 3px;
  border-radius: 8px;
  background: currentColor;
  box-sizing: border-box;
  animation: animloader 0.3s 0.45s linear infinite alternate;
  @apply text-primary;
}
/* 使用负值 animation-delay 实现提前开始 */
.loader span:nth-child(5),
.loader span:nth-child(6) {
  animation-delay: -0s; /* 中间最先开始 */
}

.loader span:nth-child(4),
.loader span:nth-child(7) {
  animation-delay: -0.1s; /* 比中间稍晚 */
}

.loader span:nth-child(3),
.loader span:nth-child(8) {
  animation-delay: -0.2s; /* 更晚一些 */
}

.loader span:nth-child(2),
.loader span:nth-child(9) {
  animation-delay: -0.3s; /* 更晚 */
}

.loader span:nth-child(1),
.loader span:nth-child(10) {
  animation-delay: -0.4s; /* 最晚开始 */
}

@keyframes animloader {
  0% {
    height: 28px;
  }
  100% {
    height: 4px;
  }
}
</style>
